import axios from "./api";

export const fetchPendingVerifications = (page = 0, tier = "") =>
  axios.get("/api/admin/verification/pending", {
    params: { page, subscriptionTier: tier || undefined },
  });

export const verifyUser = (userId) =>
  axios.post(`/api/admin/verification/${userId}/verify`);

export const markUserUnderage = (userId) =>
  axios.post(`/api/admin/verification/${userId}/underage`);
